var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',{attrs:{"config":Object.assign({}, _vm.printAreaConfig)}},[_c('v-group',{attrs:{"config":{ x: _vm.printAreaOffsetX }}},[_c('v-group',{attrs:{"config":Object.assign({}, _vm.clippingMaskConfig, {fillPatternImage: null})}},[(_vm.artwork)?_c('artwork',{attrs:{"artwork":_vm.artworks[0],"width":_vm.artworkWidth,"height":_vm.printAreaConfig.height,"parentRatio":_vm.ratio,"name_layer":_vm.name_layer,"offset":{
          x: _vm.printAreaConfig.x + _vm.printAreaOffsetX,
          y: _vm.printAreaConfig.y,
          offsetX: _vm.printAreaOffsetX
        },"rotation":_vm.rotation}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2547ee1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PreviewMockups/PrintAreaMocups.vue
// module id = 442
// module chunks = 0